module.exports = __webpack_public_path__ + "media/images/icons/caret-top-95b335ddc8cc1e63dca6c4ef941e34ea.svg";